<template>
  <div class="animated-image" v-if="id">
    <div v-if="id === 'telescope'"
      class="animated-image-wrapper animated-image-telescope"
      :class="{'animated-image-visible' : visible}">
      <img src="@/assets/images/cekt/animated/telescope-overlay.png" class="animated-image-overlay" />
      <AnimatedShape
        id="orbit"
        :color="color"
        :loop="loop"
        :visible="visible" />
      <img src="@/assets/images/cekt/animated/telescope.png" />
    </div>
  </div>
</template>
<script>
import AnimatedShape from '@/components/AnimatedShape.vue'

export default {
  name: 'ImageWithAnimation',
  props: ['id', 'loop', 'color', 'visible'],
  components: {
    AnimatedShape
  }
}
</script>

<style scoped lang="scss">
.animated-image {
  display: inline-block;
  height: 100%;
  margin: auto;
  width: 100%;

  &-wrapper {
    display: inline-block;
    height: 0;
    overflow: hidden;
    padding-bottom: 100%;
    position: relative;
    width: 100%;

    .animated-shape,
    img {
      left: 50%;
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 100%;
      z-index: 1;
    }
    img.animated-image-overlay {
      z-index: 10;
    }
    .animated-shape {
      z-index: 2;
    }
  } // END .animated-image-wrapper;

  &-telescope {
    padding-bottom: 70%;
    width: 70%;

    @include screen ('sm') {
      padding-bottom: 100%;
      width: 100%;
      max-width: 420px;
    }
  } // END .animated-image-telescope;

} // END .animated-image;
</style>
